import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import DropDownModal from 'common/components/modules/drop-down-modal'
import ImageUploader from 'admin/views/promotions/modules/image-uploader';
import { getObjectUrl }  from 'admin/api/AuthApi';
import { uploadImage }  from 'admin/api/AuthApi';
import { useSelector } from 'react-redux';
import {
   screenWidthSelector,
} from 'admin/state/modules/common/selectors';
import CheckboxLabel from 'common/components/elements/inputs/checkbox-label';
import Icon from "common/components/elements/icons";
import Switch from 'common/components/elements/inputs/switch';
// import CustomizeWatermark from 'common/components/modules/customize-watermark-d/CustomizeWatermark';
// import Button from 'common/components/elements/buttons/primary';
// import Color from './Color'


const TYPES = [
   { name: 'Image', icon: 'image', value: 'image' },
   { name: 'Text', icon: 'text', value: 'text' },
]

const CONTENT = [
   { name: 'Stories', icon: 'stories', key: 'show_watermark_on_stories' },
   { name: 'Photosets', icon: 'photosets', key: 'show_watermark_on_photosets' },
   { name: 'Videos', icon: 'videos', key: 'show_watermark_on_videos' },
   { name: 'Store', icon: 'store', key: 'show_watermark_on_store' },
   { name: 'Vault', icon: 'vault-v2', key: 'show_watermark_on_vault' },
]

const OPTIONS = [
   { key: 'include_member_name_in_watermark_when_streaming', text: 'Include the member name in watermark when streaming' },
   { key: 'include_member_email_in_watermark_when_streaming', text: "Include the member's email address in watermark when streaming" },
   { key: 'include_member_name_and_email_in_watermark_when_they_download', text: 'Include member name and email in watermark when they download' },
]

const Watermark = ({
   settings,
   value,
   onChange,
}) => {

   const screenWidth = useSelector(screenWidthSelector)
   const [loadingImage, setLoadingImage] = useState(false)
   const [data, setData] = useState({})

   useEffect(() => {
      setData({ ...data, ...value })
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [value])


   const handleFileChange = async (e) => {
      const file = e;
      const type = file ? file.type : '';
      let validFormats = ['image/jpg', 'image/jpeg', 'image/png']
      if(!validFormats.includes(type)){
         return
      }

      const formData = new FormData();
      formData.append('file', file)

      try {
         setLoadingImage(true)
         const { data: res } = await uploadImage(formData)
         const { data: fullpath } = await getObjectUrl(`images/${ res.path }`)

         changeNewData({
            ...data,
            watermark_full_src: fullpath?.[0],
            watermark_src_path: res.path,
         })
      } catch (error) {

      } finally {
         setLoadingImage(false)
      }

   }

   function changeNewData(data){
      // setData({ ...data })
      onChange('all_section', data, 'watermark')
   }

   return (
      <div className='flex flex-col gap-6 w-full'>
         <WaterMarkPreview
            data={ {
               watermark: data?.watermark_full_src,
               type: data?.type,
               siteName: data?.site_name,
               watermark_custom_position: data?.watermark_custom_position,
            } }
            styles={ {
               width: data?.watermark_size + 'px',
               height: data?.watermark_size + 'px',
               transition: 'all 0.25s',
               transform: `rotate(${ data?.watermark_rotate }deg) rotateY(${ data?.watermark_rotateY }deg)`,
               opacity: data?.opacity || 1,
               watermark_color: data?.watermark_color,
               watermark_custom_position: data?.watermark_custom_position,
               fontFamily: data?.font,
            } }
         />
         <DropDownModal
            description='Type'
            descriptionClassName='text-base text-major font-medium mb-2'
            data={ TYPES }
            onChange={ ({ value }) => {
               changeNewData({
                  ...data,
                  type: value,
               })
            } }
            uniqueId={ `modal_watermark_type` }
            activeValue={ data?.type }
            initialValue={ TYPES.find(el => el.value === data?.type) || TYPES[0] }
            wrapperClassname='[&>*:first-child]:!justify-between'
         />
         {
            data?.type === 'image' ?
               <div className='w-full h-[193px]'>
                  <ImageUploader
                     isMobile={ false }
                     handleChangeImage={ (file) => {
                        handleFileChange(file)
                     } }
                     accept='image/png,image/jpeg'
                     source={ data?.watermark_full_src }
                     loading={ loadingImage  }
                     errorMessage={ ''  }
                     uploadImageText={ `Upload photo` }
                     height={ '!h-full' }
                     screenWidth={ screenWidth }
                     showOnlyUploadButton
                  />
               </div>
               :
               <div className='flex flex-col gap-2'>
                  <p className='text-major font-medium'>Text</p>
                  <div className='border border-divider rounded-lg px-3.5 py-2.5 text-major leading-[18px]'>
                     {data?.site_name}
                  </div>
               </div>
         }
         {/* <CustomizeWatermark
            data={ data }
            type={ data?.type }
            onClickSave={ (newData) => {
               changeNewData({
                  ...data,
                  ...newData,
               })
            } }
         />
         <ContentWithWatermark
            onInputChange={ (name, value) => {
               changeNewData({
                  ...data,
                  [name]: value,
               })
            } }
            data={ {
               show_watermark_on_stories: data?.show_watermark_on_stories,
               show_watermark_on_photosets: data?.show_watermark_on_photosets,
               show_watermark_on_videos: data?.show_watermark_on_videos,
               show_watermark_on_store: data?.show_watermark_on_store,
               show_watermark_on_vault: data?.show_watermark_on_vault,
            } }
         /> */}
         <div className='flex flex-col w-full rounded-lg border border-divider'>
            {
               OPTIONS.map(({ key, text }, index) => {
                  return (
                     <CheckboxLabel
                        key={ index.toString() }
                        name={ key }
                        checked={ !!data?.[key] }
                        label={ text }
                        onChange={ (name, value) => {
                           changeNewData({
                              ...data,
                              [name]: value,
                           })
                        } }
                        position='right'
                        className='py-2.5 px-4 items-center'
                        padding='0'
                     />
                  )
               })
            }
         </div>
      </div>
   )
}

const ContentWithWatermark = ({ onInputChange, data }) => {
   return (
      <div className='flex flex-col gap-2'>
         <p className='text-major font-medium leading-6'>Show/hide the watermark on the content</p>
         <div className='flex flex-col w-full rounded-lg border border-divider py-1'>
            {
               CONTENT.map(({ name, icon, key }, index) => {
                  return (
                     <div key={ index.toString() } className='flex gap-3 justify-between w-full px-4 py-2.5 border-b border-divider last:border-none'>
                        <div className='flex gap-3'>
                           <Icon
                              name={ icon }
                              color='secondary'
                              size='xl'
                           />
                           <p className='text-major text-sm leading-5'>{name}</p>
                        </div>
                        <Switch
                           name={ key }
                           onChange={ (name, value) => onInputChange(name, value) }
                           checked={ !!data?.[key] }
                           noHorizontalMargin
                        />
                     </div>
                  )
               })
            }
         </div>
      </div>
   );
};

export const WaterMarkPreview = ({
   data: {
      watermark,
      type,
      siteName,
      watermark_custom_position,
   },
   styles,
}) => {
   const customPositions = {
      bottomStart: 'flex justify-start items-end',
      bottomCenter: 'flex justify-center items-end',
      bottomEnd: 'flex justify-end items-end',
      middleStart: 'flex justify-start items-center',
      middleCenter: 'flex justify-center items-center',
      middleEnd: 'flex justify-end items-center',
      topStart: 'flex justify-start items-start',
      topCenter: 'flex justify-center items-start',
      topEnd: 'flex justify-end items-start',
   }
   const [watermarkPosition, setWatermarkPosition] = useState(customPositions?.[watermark_custom_position])

   useEffect(() => {
      setWatermarkPosition(customPositions?.[watermark_custom_position])
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [watermark_custom_position])

   return (
      <div className='flex flex-col gap-2'>
         <p className='font-medium text-base text-major leading-6'>Preview</p>
         <div className='overflow-hidden rounded-lg relative'>
            <div
               className={ `w-full aspect-video ${ watermarkPosition }` }
               style={ {
                  // background: `url(${ backgroung })`
                  backdropFilter: 'blur(24px)',
                  backgroundImage: 'linear-gradient(180deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0.25) 99.3%)',
                  // backgroundImage: 'linear-gradient(180deg, rgba(0, 0, 0, 0.28) 0%, rgba(0, 0, 0, 0) 24.2%), linear-gradient(180.82deg, rgba(0, 0, 0, 0) 67.2%, rgba(0, 0, 0, 0.46) 99.3%)',
               } }
            >
               {/* <div className='w-full h-full relative'> */}
               {
                  type === 'image' ?
                     <img
                        src={ watermark }
                        alt=''
                        style={ styles }
                        className='absolute rounded-lg z-10'
                     />
                     :
                     <span
                        style={ {
                           opacity: styles?.opacity,
                           fontFamily: styles.fontFamily,
                           // transform: `translate${ styles?.watermark_custom_position }`,
                        } }
                        className={ `capitalize absolute text-[${ styles?.watermark_color }] ${ styles?.watermark_color }` }
                     >{siteName}</span>
               }
               {/* </div> */}
            </div>
         </div>
      </div>
   )
}

ContentWithWatermark.propTypes = {
   data: PropTypes.object,
   onInputChange: PropTypes.func,
}

WaterMarkPreview.propTypes = {
   data: PropTypes.object,
   styles: PropTypes.object,
}

Watermark.propTypes = {
   settings: PropTypes.object,
   value: PropTypes.object,
   onChange: PropTypes.func,
}

export default Watermark
